<template>
  <v-dialog
  v-if="visiblePopup"
  content-class="invite-users-popup"
  :value="visiblePopup"
  :max-width="372"
  scrollable
  @click:outside="onCloseClick"
  @keydown.esc="onCloseClick"
  >
  <v-card class="popup-wrapper" >
      <div class="content">
        <div class="invite-title">
          {{ $t('tenant.settings.add.email') }}
        </div>
        <div class="send-invitations-form">
            <div class="emails-inputs" v-for="(value, index) in emails" :key="index">
              <div class="text-field-section">
                  <text-field
                      :rules="rules"
                      type="text"
                      v-model="emails[index].email"
                      class="login"
                      :label="$t('send.invite.popup.row.label') + ' #' + (index+1)"
                      :placeholder="$t('send.invite.popup.textfield.label')"
                  />
              </div>
              <div class='delete-row-section'>
                <custom-tooltip popper-class="light-tooltip" placement="right">
                  <div slot='buttonContent'>
                <span
                  class="delete-icon material-icons"
                  :title="$t('delete')"
                  @click="deleteCurrentEmail(index)"
                >
                      highlight_off
                  </span>
                  </div>
                  <div slot="content">
                    <slot name="tooltip">
                      {{$t('delete')}}
                    </slot>
                  </div>
                </custom-tooltip>
              </div>
          </div>
          <div class="add-new-email-section">
            <div class="add-new-email-header">
                <label  class="add-new-email-add-button"  @click="addEmail">
                    <span class="plus">+</span>{{ $t('add.new.email.popup.button') }}
                </label>
            </div>
          </div>
          <div class='duplicate-email-message' v-if='isDuplicate'>
            {{$t('registration.client.info.duplicate.emails')}}
          </div>
        </div>
      </div>
      <div class="buttons">
        <v-btn small depressed class="cancel-button btn-tertiary" @click="onCloseClick"> {{ $t('confirm.cancel') }} </v-btn>
        <v-btn small depressed :disabled="saveButtonDisabled" class="save-button btn-primary" @click="onSaveClick">
          {{ $t('tenant.settings.add.email') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { rules } from '@/utils/validationUtils';
import TextField from '@/components/common/TextField.vue';
import CustomTooltip from '@/components/common/CustomTooltip.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

/* eslint-disable */
export default {
  name: 'AddEmailToDistributionListPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  components: {
    TextField,
    CustomTooltip,
  },
  props: {
    visiblePopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      index: 0,
      emails: [{email:''}],
      isFormValid: false,
      isDuplicate: false,
    }
  },
  watch: {
    emails: {
      handler() {
        const validEmailsArray = [];
        const rules = [this.emailRules.email, this.emailRules.newDomainConfiguration];
        for (let i = 0; i < this.emails.length; i += 1) {
          if (this.emails[i]) {
            const validationForCurrentRef = rules?.map(validationRule => {
              let result = false;
              if (this.emails[i].email !== '') {
                result = validationRule(this.emails[i].email);
              }
              return result;
            });
            const booleanValue = validationForCurrentRef.every(e => ((typeof (e) === 'boolean') && (e === true)));
            validEmailsArray.push(booleanValue);
          }
        }
        const emailStrings = this.emails.map(item => item.email);
        const uniqueList = emailStrings.every((email, index) => emailStrings.indexOf(email) === index);
        this.isDuplicate = !uniqueList;
        this.isFormValid = !validEmailsArray.includes(false) && uniqueList;
      },
      deep: true,
    },
  },
  computed:{
    ...mapGetters(['domains']),
    saveButtonDisabled() {
      return !this.isFormValid;
    },
    emailRules(){
      return {
        ... rules,
        endsWithCompanyDomain: v =>
        // eslint-disable-next-line implicit-arrow-linebreak
        (!!v && v.endsWith(this.domains[0])) ||
        this.$t('registration.client.info.email.should.be.in.company.domain'),
        email: v => rules.email(v) || this.$t('registration.client.info.email.is.not.valid')
      }
    },
    rules() {
      return [this.emailRules.email, this.emailRules.newDomainConfiguration];
    },
  },
  methods: {
    addEmail() {
        this.emails.push({ email:'' });
    },
    deleteCurrentEmail(index) {
      if (this.emails.length > 1) {
        this.emails.splice(index, 1);
      } else {
        this.emails = [
          {
            id: this.emails[index].id,
            email: '',
          },
        ];
      }
    },
    onCloseClick() {
      this.emails = [{email:''}];
      this.index = 0;
      this.$emit('closeAddEmailPopup');
    },
    sendInvitaions() {
      let formattedEmails = [{email:''}];
      this.emails.forEach(email => {
        if(email.email !== '') {
          formattedEmails.push(email);
        }
      });
      this.emails = formattedEmails;
    },
    onSaveClick() {
      this.$emit('saveAddEmail', this.emails);
      this.emails = [{email:''}];
      this.index = 0;    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.send-invitations-form {
 .emails-inputs {
    display: flex;
    align-items: center;
    margin-bottom: $space-5;
    .text-field-section{
        flex:0 0 rem(292);
    }
    .delete-row-section{
      flex:1;
      display: flex;
      align-items: center;
    }
    .delete-icon {
      color: var(--severity-critical);
      cursor: pointer;
      font-size: $font-size-md;
      margin-left: rem(10);
      font-weight: bolder;
    }

    .dummy-icon {
      width: $space-4;
      height: $space-4;
    }
  }
  .add-new-email-section {
    padding: $space-0;

    .add-new-email-header {
      display: flex;
      justify-content: space-between;

      .add-new-email-add-button {
        color: var(--brand-primary);
        text-transform: uppercase;
        font-size: $font-size-sm;
        font-weight: 500;
        letter-spacing: 1.07px;
        line-height: $space-4;
        text-align: center;
        margin-right: $space-3;
        cursor: pointer;

        .plus {
          font-size: $font-size-md;
        }
      }
    }
  }
  .duplicate-email-message {
    color: var(--severity-critical);
    font-size: $font-size-sm;
    margin-bottom: rem(-25);
    margin-top: $space-1;
  }
}
.invite-users-popup {
  .popup-wrapper {
    max-width: rem(372);
    padding: $space-8 $space-10;
    height: 100%;

    .content {
      .invite-title {
        text-transform: uppercase;
        color: var(--text-primary);
        font-size: $font-size-base;
        font-weight: 600;
        letter-spacing: 1.12px;
        line-height: $space-4;
        margin-bottom: $space-4;
      }
    }

    .buttons {
      text-align: right;
      padding-top: rem(30);

      .cancel-button {
        box-sizing: border-box;
        height: $space-8;
        width: rem(86);
        border-radius: $radius-sm;
        box-shadow: $shadow-sm;
      }

      .save-button {
        height: $space-8;
        width: rem(113);
        border-radius: $radius-sm;
        box-shadow: $shadow-sm;
        font-size: $font-size-sm;
        font-weight: 500;
        letter-spacing: 1.07px;
        line-height: $space-4;
        text-align: center;
        margin-left: $space-2;
      }
    }
  }
}
</style>
<style lang="scss">
@import '~@/assets/styles/design-system';

.v-dialog__content--active{
  .invite-users-popup{
    overflow-y: auto !important;
  }
}

[data-theme="dark"] {
  .invite-users-popup .save-button.v-btn--disabled {
    color: var(--text-muted) !important;
    background-color: var(--bg-tertiary) !important;
  }
}
</style>
